// --- React & Redux
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
// --- External UI Libraries
import { Drawer } from 'antd';
// --- Components
import { JobStatusForm } from './form';
// --- Styles
import './styles.scss';
// --- Hooks & Actions
import { useProductGateActions } from 'datastage/store/productGate/useProductGate';

/**
 * Job Status Drawer
 *
 * Features:
 * - Displays a drawer with job status details
 * - Integrates with Redux for state management
 *
 * @returns {JSX.Element}
 */
export const JobStatusDrawer = () => {
    const { isJobStatusOpen, jobDetails } = useSelector((state) => state.productGate);
    const { updateProductGate } = useProductGateActions();

    const handleClose = useCallback(() => {
        updateProductGate({
            isJobStatusOpen: false,
        });
    }, [updateProductGate]);

    return (
        <Drawer
            className="job-details-drawer"
            title="Job Details"
            width={900}
            placement="right"
            open={isJobStatusOpen}
            onClose={handleClose}
            closable={true}
            maskClosable={false}
            keyboard={true}
            bodyStyle={{ paddingBottom: 80 }}
        >
            <JobStatusForm details={jobDetails} />
        </Drawer>
    );
};
